const graphColours = {
  primary: '#289EED',
  secondary: '#A6CEE3',
  tertiary: '#FA9C69',
};

export default graphColours;
